import { IMessages } from '@core/models';
import { createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';

import { addMessage, delMessages, setMessages } from '../actions/messages.actions';

export const messagesInitialState: IMessages = {
  data: [],
  meta: {
    page: 1,
    rowsPerPage: 10,
    sortBy: { date: 'DESC' },
    totalRows: 0,
  },
};

export const messagesReducer = createReducer(
  messagesInitialState,

  on(setMessages, (state, { value }): IMessages => value),

  on(addMessage, (state, { value }): IMessages => {
    const addMsg: IMessages = cloneDeep(state);
    addMsg.data.push(value);
    return addMsg;
  }),

  on(delMessages, (): IMessages => messagesInitialState)
);
